export default {
  mfcCodes: undefined,
};
